import React from 'react';
import { v4 as uuidv4 } from 'uuid';


export const getImage = (url, alt)=>{
    return({ 
    key: uuidv4(),
    url: url,
    content: <img src={url} alt={alt}/>})};
